import { Parser } from 'json2csv';

export function listToCsv(json, fields) {
  const parser = new Parser({
    fields: fields || Object.keys(json[0]),
    delimiter: ';',
  });
  return parser.parse(json);
}
